import type { ReactNode } from 'react';
import * as styles from './Article.module.scss';

interface IArticleProps {
    children: ReactNode;
}

export function Article(props: IArticleProps) {
    return <article className={styles.article}>{props.children}</article>;
}
